import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import SafeHtml from 'epic-react-common/src/components/SafeHtml';
import { generateRoutePath } from 'epic-common/src/route';
import SquareButton from '../../squareButton/SquareButton';
import SwiperButton from '../../swiperButton/SwiperButton';

const SplashBlock = ({block, isDesktop, handleNext}) => {
    const {backgroundVideo, bgImage, buttonText, headline, subheader} = block;

    return (
        <div className="home--splash-block" style={{backgroundImage: `url('${bgImage}')`}}>
            {
                isDesktop &&
                <video className="home--splash-block--video" autoPlay loop muted>
                    <source src={backgroundVideo} type="video/mp4" />
                </video>
            }
            <div className="home--splash-block--content">
                <SafeHtml
                    element="h1"
                    className="main-header"
                    dangerouslySetInnerHTML={{ __html: headline }} />
                <SafeHtml
                    element="p"
                    dangerouslySetInnerHTML={{ __html: subheader }} />
                <Link to={generateRoutePath('download')}><SquareButton>{buttonText}</SquareButton></Link>
                <SwiperButton onClick={handleNext} />
            </div>
        </div>
    )
};

SplashBlock.propTypes = {
    block: PropTypes.object,
    isDesktop: PropTypes.bool,
    handleNext: PropTypes.func
};

SplashBlock.defaultProps = {
    block: {},
    isDesktop: false,
    handleNext: fn => fn
};

export default SplashBlock;
